module.exports = __webpack_public_path__ + "img/_menu_horiz_hover.b3ec5358.svg";